module.exports = __webpack_public_path__ + "img/marmelaedchen-pupi_xs.d878256b.jpg";